const cup = [
    { id: 1, x: 149, y: 408 },
    { id: 2, x: 149, y: 427 },
    { id: 3, x: 133, y: 427 },
    { id: 4, x: 133, y: 474 },
    { id: 5, x: 249, y: 474 },
    { id: 6, x: 249, y: 427 },
    { id: 7, x: 233, y: 427 },
    { id: 8, x: 233, y: 409 },
    { id: 9, x: 206, y: 392 },
    { id: 10, x: 206, y: 369 },
    { id: 11, x: 228, y: 364 },
    { id: 12, x: 243, y: 351 },
    { id: 13, x: 257, y: 365 },
    { id: 14, x: 276, y: 360 },
    { id: 15, x: 257, y: 340 },
    { id: 16, x: 282, y: 333 },
    { id: 17, x: 301, y: 318 },
    { id: 18, x: 301, y: 294 },
    { id: 19, x: 287, y: 274 },
    { id: 20, x: 269, y: 288 },
    { id: 21, x: 269, y: 263 },
    { id: 22, x: 269, y: 246 },
    { id: 23, x: 287, y: 235 },
    { id: 24, x: 269, y: 224 },
    { id: 25, x: 185, y: 224 },
    { id: 26, x: 113, y: 224 },
    { id: 27, x: 95, y: 235 },
    { id: 28, x: 113, y: 246 },
    { id: 29, x: 113, y: 263 },
    { id: 30, x: 113, y: 288 },
    { id: 31, x: 95, y: 274 },
    { id: 32, x: 81, y: 294 },
    { id: 33, x: 81, y: 318 },
    { id: 34, x: 100, y: 333 },
    { id: 35, x: 125, y: 340 },
    { id: 36, x: 106, y: 360 },
    { id: 37, x: 125, y: 365 },
    { id: 38, x: 139, y: 351 },
    { id: 39, x: 154, y: 364 },
    { id: 40, x: 173, y: 369 },
    { id: 41, x: 172, y: 392 },
    // Добавьте остальные точки
];
const compass = [
    { id: 1, x: 120, y: 439 },
    { id: 2, x: 99, y: 400 },
    { id: 3, x: 99, y: 368 },
    { id: 4, x: 111, y: 334 },
    { id: 5, x: 135, y: 311 },
    { id: 6, x: 170, y: 300 },
    { id: 7, x: 170, y: 274 },
    { id: 8, x: 160, y: 255 },
    { id: 9, x: 182, y: 238 },
    { id: 10, x: 204, y: 255 },
    { id: 11, x: 193, y: 274 },
    { id: 12, x: 193, y: 300 },
    { id: 13, x: 230, y: 314 },
    { id: 14, x: 253, y: 337 },
    { id: 15, x: 264, y: 366 },
    { id: 16, x: 264, y: 399 },
    { id: 17, x: 249, y: 433 },
    { id: 18, x: 221, y: 457 },
    { id: 19, x: 182, y: 467 },
    { id: 20, x: 141, y: 457 },
    { id: 21, x: 145, y: 424 },
    { id: 22, x: 181, y: 392 },
    { id: 23, x: 207, y: 406 },
    { id: 24, x: 194, y: 384 },
    { id: 25, x: 225, y: 341 },
    { id: 26, x: 182, y: 371 },
    { id: 27, x: 157, y: 358 },
    { id: 28, x: 170, y: 381 },


    // Добавьте остальные точки
];
const sneakers =[
    { id: 1, x: 39, y: 386 },
    { id: 2, x: 44, y: 409 },
    { id: 3, x: 100, y: 418 },
    { id: 4, x: 160, y: 418 },
    { id: 5, x: 210, y: 409 },
    { id: 6, x: 320, y: 344 },
    { id: 7, x: 319, y: 311 },
    { id: 8, x: 312, y: 287 },
    { id: 9, x: 303, y: 258 },
    { id: 10, x: 284, y: 239 },
    { id: 11, x: 260, y: 245 },
    { id: 12, x: 223, y: 225 },
    { id: 13, x: 199, y: 240 },
    { id: 14, x: 228, y: 254 },
    { id: 15, x: 173, y: 251 },
    { id: 16, x: 212, y: 282 },
    { id: 17, x: 153, y: 274 },
    { id: 18, x: 194, y: 303 },
    { id: 19, x: 140, y: 297 },
    { id: 20, x: 181, y: 320 },
    { id: 21, x: 117, y: 318 },
    { id: 22, x: 157, y: 346 },
    { id: 23, x: 92, y: 342 },
    { id: 24, x: 73, y: 358 },
    { id: 25, x: 48, y: 376 },
    { id: 26, x: 97, y: 393 },
    { id: 27, x: 188, y: 388 },
    { id: 28, x: 307, y: 327 },
    { id: 29, x: 291, y: 279 },
    { id: 30, x: 265, y: 267 },
    { id: 31, x: 155, y: 365 },

]
const heard =[
    { id: 1, x: 91, y: 337 },
    { id: 2, x: 92, y: 302 },
    { id: 3, x: 113, y: 282 },
    { id: 4, x: 139, y: 273 },
    { id: 5, x: 166, y: 283 },
    { id: 6, x: 182, y: 303 },
    { id: 7, x: 193, y: 283 },
    { id: 8, x: 225, y: 273 },
    { id: 9, x: 251, y: 282 },
    { id: 10, x: 270, y: 300 },
    { id: 11, x: 273, y: 330 },
    { id: 12, x: 261, y: 363 },
    { id: 13, x: 237, y: 390 },
    { id: 14, x: 208, y: 417 },
    { id: 15, x: 183, y: 443 },
    { id: 16, x: 152, y: 414 },
    { id: 17, x: 123, y: 383 },
    { id: 18, x: 99, y: 352 },
    { id: 19, x: 148, y: 352 },
    { id: 20, x: 159, y: 372 },
    { id: 21, x: 175, y: 325 },
    { id: 22, x: 202, y: 391 },
    { id: 23, x: 215, y: 348 },
    { id: 24, x: 225, y: 368 },
    { id: 25, x: 237, y: 348 },
    { id: 26, x: 259, y: 349 },
]
const airplane =[
    { id: 1, x: 298, y: 273 },
    { id: 2, x: 325, y: 281 },
    { id: 3, x: 317, y: 308 },
    { id: 4, x: 331, y: 332 },
    { id: 5, x: 317, y: 343 },
    { id: 6, x: 322, y: 364 },
    { id: 7, x: 291, y: 349 },
    { id: 8, x: 259, y: 352 },
    { id: 9, x: 226, y: 355 },
    { id: 10, x: 197, y: 356 },
    { id: 11, x: 197, y: 384 },
    { id: 12, x: 176, y: 383 },
    { id: 13, x: 146, y: 396 },
    { id: 14, x: 134, y: 380 },
    { id: 15, x: 153, y: 361 },
    { id: 16, x: 119, y: 334 },
    { id: 17, x: 125, y: 354 },
    { id: 18, x: 104, y: 353 },
    { id: 19, x: 76, y: 349 },
    { id: 20, x: 48, y: 339 },
    { id: 21, x: 33, y: 321 },
    { id: 22, x: 45, y: 306 },
    { id: 23, x: 64, y: 318 },
    { id: 24, x: 88, y: 324 },
    { id: 25, x: 102, y: 307 },
    { id: 26, x: 79, y: 301 },
    { id: 27, x: 60, y: 293 },
    { id: 28, x: 91, y: 284 },
    { id: 29, x: 124, y: 284 },
    { id: 30, x: 160, y: 288 },
    { id: 31, x: 191, y: 283 },
    { id: 32, x: 223, y: 280 },
    { id: 33, x: 210, y: 301 },
    { id: 34, x: 224, y: 308 },
    { id: 35, x: 277, y: 313 },
    { id: 36, x: 292, y: 293 },
]
const megaphone =[
    { id: 1, x: 47, y: 374 },
    { id: 2, x: 55, y: 406 },
    { id: 3, x: 32, y: 397 },
    { id: 4, x: 30, y: 368 },
    { id: 5, x: 53, y: 352 },
    { id: 6, x: 74, y: 342 },
    { id: 7, x: 74, y: 365 },
    { id: 8, x: 86, y: 380 },
    { id: 9, x: 86, y: 334 },
    { id: 10, x: 102, y: 311 },
    { id: 11, x: 111, y: 293 },
    { id: 12, x: 123, y: 321 },
    { id: 13, x: 141, y: 346 },
    { id: 14, x: 162, y: 366 },
    { id: 15, x: 139, y: 327 },
    { id: 16, x: 127, y: 300 },
    { id: 17, x: 114, y: 268 },
    { id: 18, x: 130, y: 260 },
    { id: 19, x: 148, y: 281 },
    { id: 20, x: 165, y: 304 },
    { id: 21, x: 179, y: 332 },
    { id: 22, x: 191, y: 362 },
    { id: 23, x: 197, y: 383 },
    { id: 24, x: 182, y: 394 },
    { id: 25, x: 154, y: 383 },
    { id: 26, x: 120, y: 380 },
    { id: 27, x: 93, y: 392 },
    { id: 28, x: 68, y: 418 },
    { id: 29, x: 83, y: 441 },
    { id: 30, x: 102, y: 460 },
    { id: 31, x: 135, y: 444 },
    { id: 32, x: 115, y: 433 },
    { id: 33, x: 102, y: 416 },
]



export const mapPoint =[cup, compass, sneakers, heard, airplane, megaphone]
